/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TechnicianGroupModalComponent} from './technician-group-modal.component';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {InputModule} from '../../../../shared/input/input.module';
import {ActiveInputModule} from '../active-input/active-input.module';
import {ChipInputModule} from '../../../../shared/chip-input/chip-input.module';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';
import {WarningsModule} from '../../../../shared/warnings/warnings.module';

@NgModule({
    declarations: [TechnicianGroupModalComponent],
    imports: [
        CommonModule,
        GenericModalModule,
        InputModule,
        ActiveInputModule,
        ChipInputModule,
        TooltipModule,
        WarningsModule
    ]
})
export class TechnicianGroupModalModule {
}
